'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';
import { setDisabled } from '@/js/modules/set_disabled';

onPageLoad(() => {
  $(function () {
    const showBoardLimitBodyIds = [
      'designer-projects',
      'client-projects',
      'templates-contracts',
      'templates-board_collections',
      'my_templates-contract_presets',
    ];
    if (showBoardLimitBodyIds.includes($('body').attr('id'))) {
      switch ($('body').data().systemFlash) {
        case 'show-board-limit-modal':
          $('.modal--board-limit').modal();
          break;
        case 'show-subscription-downgrade-modal':
          $('.modal--subscription-downgrade').modal({
            escapeClose: false,
            clickClose: false,
            showClose: false,
          });
          break;
      }
    }

    $(document).on('click', '.designer-projects-promo__hide', (e) => {
      $.post('/users/xhr_set_preference', {
        key: 'hide_projects_referral_promo_block',
        value: true,
      });
      $(e.target).closest('.designer-projects__board').fadeOut('fast');

      return false;
    });

    $(document).on('click', '.learning-session-cta-projects__hide', (e) => {
      $.post('/users/xhr_set_preference', {
        key: 'hide_learning_session_cta',
        value: true,
      });
      $(e.target)
        .closest('.designer-projects__board, .kanban-card--learning-session-cta')
        .fadeOut('fast');

      return false;
    });

    $(document).on('click', '.learning-session-cta-videos__hide', (e) => {
      $.post('/users/xhr_set_preference', {
        key: 'hide_learning_session_cta_on_videos_page',
        value: true,
      });
      $(e.target).closest('.learning-session-cta-videos').fadeOut('fast');

      return false;
    });

    const resizeProjectsPromo = () => {
      const maxWidth = parseInt($('.designer-projects-promo__content').css('max-width'));
      const actuallWidth = parseInt($('.designer-projects__board--promo').width());
      const scaleValue = actuallWidth / maxWidth;
      $('.designer-projects-promo__content').css({
        transform: `scale(${scaleValue})`,
      });
    };
    resizeProjectsPromo();
    $(window).on('resize', function () {
      resizeProjectsPromo();
    });

    const pagesWithPublishModal = [
      'boards',
      'board-preview',
      'boards-preview',
      'fp-board-preview',
      'projects-dashboard',
    ];
    const bodyId = $('body').attr('id');

    if (pagesWithPublishModal.includes(bodyId)) {
      $(document).on('blur', '.page-header--project-name', (e) => {
        let name = $(e.target).text();
        const normalizedName = name.trim();

        if (normalizedName !== name) {
          name = normalizedName;
          e.target.innerText = normalizedName;
        }

        const projectId = parseInt($('meta[name=project-id]').attr('content'));
        $('.df-tooltip--project-name-validation-error').remove();

        $.post(`/projects/${projectId}/xhr_update_name`, { name }).fail((xhr, _status, _error) => {
          const errorJSON = xhr.responseJSON;
          const tooltip = `<span class="df-tooltip df-tooltip--project-name-validation-error">
          <span class="df-tooltip__text">Project ${errorJSON.join(', ').toLowerCase()}.</span>
        </span>`;
          $(tooltip).insertBefore($('.page-header--project-name'));
        });
      });
    }
  });

  $(document).on('ajax:before', '.project-requests__continue-questionnaire-link', ({ target }) => {
    target.classList.add('button-loading');
  });

  $(document).on('ajax:success', '.project-requests__continue-questionnaire-link', ({ target }) => {
    setDisabled(target, true);
  });

  $(document).on(
    'ajax:complete',
    '.project-requests__continue-questionnaire-link',
    ({ target }) => {
      target.classList.remove('button-loading');
    }
  );

  $(document).on(
    'click',
    '.h-s-button--add-designer, .designer-selector__add-designer-link',
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      const targetUrl = $(this).attr('href');
      window.location.href = targetUrl;
    }
  );
});
